import { saveEventOnAnalytics } from '../../../../utils/helpers';

class AuditoriaIntegradaIcms {
  static get $inject() {
    return ['$scope', 'gql']
  }

  constructor($scope, gql) {
    this.apply = fun => $scope.$apply(fun)
    this.gql = gql
    this.lancamentoFilter = {}

    this.mainButtons = [
      {
        id: 'lancamentos',
        icon: 'fa-list',
        title: 'Lançamentos',
        secondary: 'Visualizar os lançamentos fiscais agrupados por nota.'
      },
      {
        id: 'extratos',
        icon: 'fa-file-text',
        title: 'Extratos',
        secondary: 'Visualizar os extratos da SEFIN.'
      },
      {
        id: 'conferencia-de-notas',
        icon: 'fa-check-square-o',
        title: 'Conferência de Notas',
        secondary: 'Conferir os valores das suas notas com a SEFIN.'
      }
    ]

    $scope.$watch(
      () => this.activeTab,
      (tab) => {
        if (tab == undefined || tab == 'inicio') {
          return;
        }
        saveEventOnAnalytics('AuditoriaIntegradaICMSModulosMaisUsados', tab)
      }
    )
  }

  get isConferenciaNotasContratada() {
    return this.empresa.ferramentasDisponiveis.includes('conferencia-notas')
  }

  hasAcesso(empresa) {
    return empresa.ferramentasDisponiveis.includes("auditoria-integrada-icms")
  }

  listLancamentosFor(extrato) {
    this.lancamentoFilter = { numeroExtrato: extrato.numero }
    this.activeTab = 'lancamentos'
  }
}

angular.module("eficienciaFiscalModule").component("auditoriaIntegradaIcms", {
  controller: AuditoriaIntegradaIcms,
  bindings: {
    contratoId: '<'
  },
  template: `
    <div class="row">
      <loading promise="$ctrl.empresaLoadingPromise" on-retry="$ctrl.$onInit()">
        <div class="col-xs-12">
          <ef-empresa-selector contrato-id="$ctrl.contratoId" name="empresa" ng-model="$ctrl.empresa"
            filter="$ctrl.hasAcesso($empresa)" cache-as="auditoria-integrada-icms"
            loading-promise="$ctrl.empresaLoadingPromise" required>
          </ef-empresa-selector>
        </div>

        <div class="col-xs-12" ng-class="{'no-margin-tabs': $ctrl.empresas.length === 1}">
          <ef-tabs active="$ctrl.activeTab" ng-if="$ctrl.empresa">
            <ef-tabs-tab id="inicio">
              <div class="buttons-container">
                <div ng-repeat="button in $ctrl.mainButtons" ng-click="$ctrl.activeTab = button.id"
                  class="btn btn-primary btn-outlined" ng-show="!button.flag || $ctrl.featureFlags[button.flag]">
                  <highlighted style="white-space: normal">
                    <main>
                      <i class="fa {{ button.icon }}" style="margin-bottom: 10px;"></i> </br>
                      {{ button.title }}
                    </main>
                    <secondary>{{ button.secondary }}</secondary>
                  </highlighted>
                </div>
              </div>
            </ef-tabs-tab>

            <ef-tabs-tab id="lancamentos" label="Lançamentos">
              <div>
                <lancamento-operations tab-name="'lancamentos'" empresa-id="$ctrl.empresa.id"
                  on-voltar="$ctrl.activeTab = 'inicio'">
                </lancamento-operations>
                <lancamento-filter ng-model="$ctrl.lancamentoFilter"></lancamento-filter>
                <lancamento-list contrato-id="$ctrl.contratoId" empresa-id="$ctrl.empresa.id"
                  filter="$ctrl.lancamentoFilter"></lancamento-list>
              </div>
            </ef-tabs-tab>

            <ef-tabs-tab id="extratos" label="Extratos">
              <div>
                <lancamento-operations tab-name="'extratos'" empresa-id="$ctrl.empresa.id" contrato-id="$ctrl.contratoId"
                  on-voltar="$ctrl.activeTab = 'inicio'">
                </lancamento-operations>
                <extrato-filter on-change="filter = $newFilter"></extrato-filter>
                <extrato-list empresa-id="$ctrl.empresa.id" filter="filter"
                  on-list-lancamentos="$ctrl.listLancamentosFor(extrato)">
                </extrato-list>
              </div>
            </ef-tabs-tab>

            <ef-tabs-tab id="conferencia-de-notas" label="Conferência de notas">
              <div ng-if="$ctrl.isConferenciaNotasContratada">
                <lancamento-operations empresa-id="$ctrl.empresa.id" on-voltar="$ctrl.activeTab = 'inicio'">
                </lancamento-operations>
                <conferencia-nfe-filter on-change="filter = $newFilter"></conferencia-nfe-filter>
                <conferencia-nfe-list empresa-id="$ctrl.contratoId" filial="$ctrl.empresa" filter="filter">
                </conferencia-nfe-list>
              </div>

              <div ng-if="!$ctrl.isConferenciaNotasContratada">
                <lancamento-operations empresa-id="$ctrl.empresa.id" on-voltar="$ctrl.activeTab = 'inicio'">
                </lancamento-operations>
                <highlighted>
                  <main>Este recurso não foi contratado para a filial selecionada.</main>
                  <secondary>
                    <a href="javascript:Intercom('show')">Clique aqui</a> para falar com um de nossos consultores.
                  </secondary>
                </highlighted>
              </div>
            </ef-tabs-tab>
          </ef-tabs>
        </div>

        <div class="col-xs-12" ng-if="!$ctrl.empresa">
          <highlighted>
            <main>Nenhuma empresa selecionada</main>
          </highlighted>
        </div>
      </loading>
    </div>
  `
})
